import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISector, ISectorsInitialState, ISectorsList } from '@types';

import { initialSectors } from './initialState';

export const sectorsSlice = createSlice({
    name: 'sectors',
    initialState: initialSectors(),
    reducers: {
        setSectors(state: ISectorsInitialState, action: PayloadAction<ISectorsList>) {
            state.sectorsList = action.payload;
        },

        setSector(state: ISectorsInitialState, action: PayloadAction<ISector | null>) {
            state.sector = action.payload;
        },
    },
});
